/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from 'react';
import './App.css';

function App() {
  const currentPlayer2 = useRef(null);

  const gup = (name) => {
    const url = window.location.href;
    const _name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    const regexS = '[\\?&]' + _name + '=([^&#]*)';
    const regex = new RegExp(regexS);
    const results = regex.exec(url);
    return results === null ? null : results[1];
  };

  const defaultParams = {
    controls: true,
    muted: true,
    playing: true,
    autoplay: true,
    isTrailer: false,
    isAutoFullscreen: true,
    isAutoPIP: true,
    loop: false,
    podId: null,
    imgUrl: '',
    pk: '',
    vm: false,
    showProgramImage: true,
    showProgramName: true,
    showCountdown: true,
    showProgramDatetime: true,
    showBackgroundBanner: true,
    opacityBackgroundBanner: 0.8,
    blurBackgroundBanner: 5,
    isRehearsal: false,
  };

  const handleCreatePlayer = async () => {
    const url = new URL(window.location.href);
    if (!url.searchParams) {
      url.searchParams = {
        get: (param) => {
          console.log('get', param);
          return gup(param);
        },
      };
    }
    const options = { ...defaultParams };
    let programmeId = url.searchParams.get('programmeId');

    for (const key in defaultParams) {
      let value = url.searchParams.get(key);

      if (value) {
        value === 'true' && (value = true);
        value === 'false' && (value = false);
        options[key] = value;
      }
    }

    try {
      window.InitPlayer('player', {
        programme_id: programmeId,
        options: {
          ...options,
          getPlayerState: (player) => {
            console.log('getPlayerStategetPlayerState');

            currentPlayer2.current = player;
          },
        },
      });
    } catch (error) {}
  };

  const handleMessage = (event) => {
    if (event.data) {
      if (event.data.event === 'pause-player2') {
        currentPlayer2.current && currentPlayer2.current.pause();
      }
    }
  };

  useEffect(() => {
    window.addEventListener('message', handleMessage);

    handleCreatePlayer();

    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);

  return (
    <div className='App'>
      <div
        style={{
          width: '100%',
          height: '100%',
          position: 'absolute',
          top: 0,
        }}
        id='player'
      />
    </div>
  );
}

export default App;
